import { render, staticRenderFns } from "./ipad-MT4.vue?vue&type=template&id=00c54823&scoped=true&"
import script from "./ipad-MT4.vue?vue&type=script&lang=js&"
export * from "./ipad-MT4.vue?vue&type=script&lang=js&"
import style0 from "./ipad-MT4.vue?vue&type=style&index=0&id=00c54823&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c54823",
  null
  
)

export default component.exports